<ng-template #editableTemplateRef
             let-cellData
             let-rowData="rowData">
  @if (dataSource$ | async; as dataSource) {
    @if (dataSource.length) {
      <p-select #select
                class="sc-table-dropdown"
                appendTo="body"
                [dataKey]="dataKey"
                [optionLabel]="optionLabel"
                [optionValue]="optionValue"
                scrollHeight="auto"
                [placeholder]="placeholder"
                [showClear]="showClear"
                [ngModel]="cellData"
                [options]="dataSource"
                (onChange)="onSelectionChange($event, rowData, cellData, select)">
        <ng-template pTemplate="selectedItem">
          <ng-template *ngTemplateOutlet="itemTpl"></ng-template>
        </ng-template>
      </p-select>
    } @else {
      <span scOverflowTooltip>{{ displayExpr(cellData) }}</span>
    }
    <ng-template #itemTpl>
      <span scOverflowTooltip>{{ displayExpr(cellData) }}</span>
    </ng-template>
  }
</ng-template>